<template>
  <div class="lista-wizard container" style="width: 100%">
    <div class="broadcast-html">
      <detalhe :broadcast="broadcasts_selecionado"></detalhe>
      <div class="cabecalho">
        <BaseHeader
          title="Todos os Broadcasts"
          :navigation="navigation"
        ></BaseHeader>
        <div class="box-total" style="justify-content: center;">
          <p class="total-vendas">
            Total de {{ totalText }}:
            <span>{{ total }}</span>
          </p>
        </div>
        <div class="flex-test">
          <div class="filter-search">
            <b-form-input
              @input="debounce"
              class="flex input-search"
              id="search-list"
              v-model="filter"
              placeholder="Pesquisar Broadcast"
              type="search"
              style="padding-left: 45px !important;"
            ></b-form-input>
            <Multiselect
              class="status-broadcast-select"
              v-model="selected_public"
              :options="['Todos', 'Enviados', 'Deletados']"
              @input="selectPublic()"
              style="width: 220px"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              selectedLabel=""
              :allow-empty="false"
              :searchable="false"
            />
            <svg style="position: absolute; top: 15px; left: 17px; z-index: 3;" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.5339 15.8416L11.9803 12.2879M13.9001 7.6722C13.9001 11.2816 10.974 14.2077 7.36458 14.2077C3.75514 14.2077 0.829102 11.2816 0.829102 7.6722C0.829102 4.06275 3.75514 1.13672 7.36458 1.13672C10.974 1.13672 13.9001 4.06275 13.9001 7.6722Z" stroke="#81858E" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <svg style="position: absolute; top: 15px; left: 313px; z-index: 100;" width="20" height="20" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.4558 1.6499H1.45581L6.65581 7.7989V12.0499L9.25581 13.3499V7.7989L14.4558 1.6499Z" style="stroke: var(--gray03);" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="div-btn">
            <button class="btn-reload" @click="reload">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                fill="#fff" 
                viewBox="0 0 256 256"
              >
                <path
                  d="M200.49,183.51a12,12,0,0,1,0,17c-1.13,1.12-28,27.51-72.49,27.51-33.71,0-59.35-17.46-76-33.86V208a12,12,0,0,1-24,0V160a12,12,0,0,1,12-12H88a12,12,0,0,1,0,24H64.12c13.1,14.32,35.08,32,63.88,32,34.63,0,55.31-20.28,55.51-20.49A12,12,0,0,1,200.49,183.51ZM216,36a12,12,0,0,0-12,12V61.86C187.35,45.46,161.71,28,128,28,83.54,28,56.64,54.39,55.51,55.51a12,12,0,0,0,17,17C72.69,72.28,93.37,52,128,52c28.8,0,50.78,17.68,63.88,32H168a12,12,0,0,0,0,24h48a12,12,0,0,0,12-12V48A12,12,0,0,0,216,36Z"
                ></path>
              </svg>
            </button>
            <router-link to="/dynamicRoute/apps/broadcast/wizard">
              <button class="new-broadcast">Criar um Broadcast</button>
            </router-link>
          </div>
        </div>
      </div>
      <div>
        <div>
          <button
            class="btns-actions"
            v-on:click="actionDeletar"
            :disabled="!showBtnDelete"
          >
            <svg
              class="espacamento-svg-action"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.75 3.5H2.91667H12.25"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.66669 3.5V2.33333C4.66669 2.02392 4.7896 1.72717 5.0084 1.50838C5.22719 1.28958 5.52394 1.16667 5.83335 1.16667H8.16669C8.47609 1.16667 8.77283 1.28958 8.99164 1.50838C9.21045 1.72717 9.33335 2.02392 9.33335 2.33333V3.5H4.66669ZM11.0834 3.5V11.6667C11.0834 11.9761 10.9604 12.2728 10.7416 12.4916C10.5228 12.7104 10.2261 12.8333 9.91669 12.8333H4.08335C3.77394 12.8333 3.47719 12.7104 3.2584 12.4916C3.0396 12.2728 2.91669 11.9761 2.91669 11.6667V3.5H11.0834Z"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.16669 6.41667V9.91667"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.83331 6.41667V9.91667"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Deletar
          </button>
          <button
            :disabled="!showBtnEdit"
            v-if="btnsActionsEditar"
            class="btns-actions"
            v-on:click="actionEditar()"
          >
            <svg
              class="espacamento-svg-action"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.33334 8.16666H5.83334V11.6667"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.75 12.25L5.83333 8.16666"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.6667 5.83334H8.16666V2.33334"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.16666 5.83333L12.25 1.75"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Editar
          </button>
          <button
            :disabled="!showBtnCancel"
            v-if="btnsActionsEditar"
            class="btns-actions"
            v-on:click="actionDelete()"
          >
            <svg
              class="espacamento-svg-action"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.17385 4.99927L9.75374 1.42724C9.9105 1.27045 9.99859 1.05779 9.99859 0.836055C9.99859 0.614321 9.9105 0.40167 9.75374 0.244874C9.59697 0.0880859 9.38434 0 9.16264 0C8.94094 0 8.72831 0.0880859 8.57154 0.244874L4.99998 3.82524L1.42846 0.244874C1.27169 0.0880859 1.05906 0 0.83736 0C0.615657 0 0.403028 0.0880859 0.246263 0.244874C0.0894969 0.40167 0.00142358 0.614321 0.00142358 0.836055C0.00142358 1.05779 0.0894969 1.27045 0.246263 1.42724L3.82611 4.99927L0.246263 8.57134C0.168229 8.64878 0.106298 8.74087 0.06403 8.84237C0.0217624 8.94378 0 9.05261 0 9.16252C0 9.27252 0.0217624 9.38134 0.06403 9.48276C0.106298 9.58426 0.168229 9.67635 0.246263 9.7537C0.323655 9.83181 0.415733 9.89375 0.517185 9.93597C0.618637 9.97827 0.727457 10 0.83736 10C0.947262 10 1.05608 9.97827 1.15754 9.93597C1.25899 9.89375 1.35107 9.83181 1.42846 9.7537L4.99998 6.17331L8.57154 9.7537C8.64897 9.83181 8.74105 9.89375 8.84253 9.93597C8.94394 9.97827 9.05275 10 9.16264 10C9.27262 10 9.38143 9.97827 9.48283 9.93597C9.58432 9.89375 9.6764 9.83181 9.75374 9.7537C9.83183 9.67635 9.89377 9.58426 9.93598 9.48276C9.97827 9.38134 10 9.27252 10 9.16252C10 9.05261 9.97827 8.94378 9.93598 8.84237C9.89377 8.74087 9.83183 8.64878 9.75374 8.57134L6.17385 4.99927Z"
              />
            </svg>
            Cancelar envio
          </button>
        </div>
        <div v-if="emailsLoading === true" class="mb-5">
          <div v-for="item in 10" :key="item.id">
            <b-skeleton
              width="100%"
              height="60px"
              style="border-radius: 10px; margin-top: 5px"
            ></b-skeleton>
          </div>
        </div>

        <b-table
          v-else
          :fields="selected_public == 'Deletados' ? fieldsDelete : selected_public == 'Enviados' ? fieldsSent : fields"
          show-empty
          borderless	
          small
          stacked="md"
          :items="broadcasts"
          :tbody-tr-class="rowClass"
          :filter-included-fields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          sort-direction="asc"
        >
          <template #empty>
            <p class="title text-center-empty">
              {{ emptyText }}
            </p>
          </template>
          <template #emptyfiltered>
            <p class="title text-center-empty">
              {{ emptyText }}
            </p>
          </template>
          <template v-slot:head(user_id)>
            <label class="check">
              <b-form-checkbox-group
                style="padding-left: 0px"
                id="checkbox-group-all"
                v-model="status_auto2"
                @change="clickCheckAll"
                :disabled="broadcasts.every(broad => broad.status > 0)"
                class="reset2"
                name="flavour-all"
              >
                <b-form-checkbox value="xx"></b-form-checkbox>
              </b-form-checkbox-group>
            </label>
          </template>
          <template #cell(user_id)="row">
            <b-form-checkbox-group
              :id="`checkbox-group-` + row.item.id"
              v-model="status_auto"
              @change="clickCheck()"
              class="reset2"
              :name="`flavour-` + row.item.id"
              :disabled="row.item.status > 0"
            >
              <b-form-checkbox :value="row.item.id"></b-form-checkbox>
            </b-form-checkbox-group>
          </template>
          <template #cell(id)="row">
            <div class="title-open" v-on:click=" loadingView ? '' : insereModal(row.item)">
              {{ row.item.id }}
            </div>
          </template>
          <template #cell(title)="row">
            <div
              class="title-open title-espacamento"
              v-on:click=" loadingView ? '' : insereModal(row.item)"
            >
              {{ row.item.title }}
            </div>
          </template>
          <template #cell(status)="row">
            <div class="title-open" v-on:click=" loadingView ? '' : insereModal(row.item)">
              {{ row.item.status_text }}
            </div>
          </template>
          <template #cell(from_address)="row">
            <div class="title-open" v-on:click=" loadingView ? '' : insereModal(row.item)">
              {{ row.item.from_address }}
            </div>
          </template>
          <template #cell(selected_count)="row">
            <div
              v-if="
                row.item.status === 4 ||
                row.item.status === 3 ||
                row.item.status === 5 ||
                row.item.status === 2 ||
                row.item.status === 1 ||
                row.item.status === 0
              "
            >
              <div
                v-if="row.item.selected_count === null"
                class="content-entregues title-open"
                v-on:click=" loadingView ? '' : insereModal(row.item)"
              >
                <div class="pointer-entregues"></div>
                <p class="value-allblack">{{ row.item.filtereds_count }}</p>
              </div>
              <div
                v-else
                class="content-entregues title-open"
                v-on:click=" loadingView ? '' : insereModal(row.item)"
              >
                <div class="pointer-entregues"></div>
                <p class="value-allblack">{{ row.item.selected_count }}</p>
              </div>
            </div>
          </template>
          <template #cell(fetched_count)="row">
            <div
              v-if="
                row.item.status === 4 ||
                row.item.status === 3 ||
                row.item.status === 5 ||
                row.item.status === 2 ||
                row.item.status === 1 ||
                row.item.status === 0
              "
            >
              <div
                v-if="
                  row.item.fetched_count === 1 &&
                  row.item.selected_count !== 1
                "
                class="content-entregues title-open"
                v-on:click=" loadingView ? '' : insereModal(row.item)"
              >
                <div class="pointer-entregues"></div>
                <p class="value-allblack">{{ row.item.selected_count }}</p>
              </div>
              <div
                v-else-if="row.item.fetched_count === null"
                class="content-entregues title-open"
                v-on:click=" loadingView ? '' : insereModal(row.item)"
              >
                <div class="pointer-entregues"></div>
                <p class="value-allblack">{{ row.item.filtereds_count }}</p>
              </div>
              <div
                v-else
                class="content-entregues title-open"
                v-on:click=" loadingView ? '' : insereModal(row.item)"
              >
                <div class="pointer-entregues"></div>
                <p class="value-allblack">{{ row.item.fetched_count }}</p>
              </div>
            </div>
          </template>
          <template #cell(delivereds_count)="row">
            <div
              v-if="
                row.item.status === 4 ||
                row.item.status === 3 ||
                row.item.status === 5
              "
              v-on:click=" loadingView ? '' : insereModal(row.item)"
            >
              <div>
                <b-skeleton
                v-if="row.item.delivereds_count == undefined"
                width="78px"
                height="32.73px"
                class="event-skeleton"
                ></b-skeleton>
                <div class="content-enviados title-open" v-else>
                  <div class="pointer-enviados"></div>
                  <p class="value-enviados">
                    {{ row.item.delivereds_count }} /
                    {{ row.item.percentageDelivereds }}%
                  </p>
                </div>
              </div>
            </div>
          </template>
          <template #cell(opens_count)="row">
            <div
              v-if="
                row.item.status === 4 ||
                row.item.status === 3 ||
                row.item.status === 5
              "
              v-on:click=" loadingView ? '' : insereModal(row.item)"
            >
              <div>
                <b-skeleton
                v-if="row.item.opens_count == undefined"
                width="78px"
                height="32.73px"
                class="event-skeleton"
                ></b-skeleton>

                <div class="content-abertos title-open" v-else>
                  <div class="pointer-abertos"></div>
                  <p class="value-abertos">
                    {{ row.item.opens_count }} / {{ row.item.percentageOpen }}%
                  </p>
                </div>
              </div>
            </div>
          </template>
          <template #cell(clicks_count)="row">
            <div
              v-if="
                row.item.status === 4 ||
                row.item.status === 3 ||
                row.item.status === 5
              "
              v-on:click=" loadingView ? '' : insereModal(row.item)"
            >
              <div>
                <b-skeleton
                v-if="row.item.clicks_count == undefined"
                width="78px"
                height="32.73px"
                class="event-skeleton"
                ></b-skeleton>

                <div class="content-clicados title-open" v-else>
                  <div class="pointer-clicados"></div>
                  <p class="value-clicados">
                    {{ row.item.clicks_count }} / {{ row.item.percentageClick }}%
                  </p>
                </div>
              </div>
            </div>
          </template>
          <template #cell(send_at)="row">
            <div class="title-open" v-on:click=" loadingView ? '' : insereModal(row.item)">
              {{ row.item.send_at | moment("DD/MM/YYYY HH:mm") }}
            </div>
          </template>
          <template #cell(restore)="row">
            <div class="deleted-actions">
              <button v-if="selected_public == 'Deletados'" @click="loadingRestore ? '' : restore(row.item.id, row.item.selected_count)" class="restore" :class="{'loading' : loadingRestore == row.item.id}">Restaurar</button>
              <div v-else title="Eventos" @click="viewEvents(row.item.id)">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style="fill: inherit;" viewBox="0 0 256 256"><path d="M228.44,89.34l-96-64a8,8,0,0,0-8.88,0l-96,64A8,8,0,0,0,24,96V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V96A8,8,0,0,0,228.44,89.34ZM96.72,152,40,192V111.53Zm16.37,8h29.82l56.63,40H56.46Zm46.19-8L216,111.53V192ZM128,41.61l81.91,54.61-67,47.78H113.11l-67-47.78Z"></path></svg>
              </div>
              <div title="Detalhes" @click="loadingView ? '' : insereModal(row.item)" :class="{'loading' : loadingView == row.item.id}">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" style="stroke: inherit;" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
              </div>
            </div>
          </template>
        </b-table>

        <div class="espace-pagination" v-if="emailsLoading === false">
          <b-row>
            <b-col>
              <Paginate
                v-if="totalPage > 0"
                :totalPages="totalPage"
                :activePage="currentPage"
                @to-page="toPage"
              />
            </b-col>
          </b-row>
        </div>
      </div>
      <b-modal
        id="my-modal-cancel"
        ref="my-modal-cancel"
        title="Cancelar envio"
        hide-footer
        centered
      >
        <div class="d-flex">
          <div class="pointerx"></div>
          <p class="title-modal mb-3">
            O que fazer com o Broadcast após o cancelamento do envio?
          </p>
        </div>
        <div class="content-option-modal">
          <div
            v-if="trash"
            class="options-modal"
            @click="trash = false"
          >
            <div>
              <svg
                class="svg-modal"
                width="50"
                height="50"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                  fill="#EDEDF0"
                  fill-opacity="0.5"
                />
                <path
                  d="M17.1579 18.8H17.7895C17.957 18.8 18.1176 18.7368 18.2361 18.6243C18.3545 18.5117 18.4211 18.3591 18.4211 18.2C18.4211 18.0409 18.3545 17.8883 18.2361 17.7757C18.1176 17.6632 17.957 17.6 17.7895 17.6H17.1579C16.9904 17.6 16.8297 17.6632 16.7113 17.7757C16.5929 17.8883 16.5263 18.0409 16.5263 18.2C16.5263 18.3591 16.5929 18.5117 16.7113 18.6243C16.8297 18.7368 16.9904 18.8 17.1579 18.8ZM19.6842 22.4H17.1579C16.9904 22.4 16.8297 22.4632 16.7113 22.5757C16.5929 22.6882 16.5263 22.8409 16.5263 23C16.5263 23.1591 16.5929 23.3118 16.7113 23.4243C16.8297 23.5368 16.9904 23.6 17.1579 23.6H19.6842C19.8517 23.6 20.0124 23.5368 20.1308 23.4243C20.2492 23.3118 20.3158 23.1591 20.3158 23C20.3158 22.8409 20.2492 22.6882 20.1308 22.5757C20.0124 22.4632 19.8517 22.4 19.6842 22.4ZM19.6842 20H17.1579C16.9904 20 16.8297 20.0632 16.7113 20.1757C16.5929 20.2882 16.5263 20.4409 16.5263 20.6C16.5263 20.7591 16.5929 20.9118 16.7113 21.0243C16.8297 21.1368 16.9904 21.2 17.1579 21.2H19.6842C19.8517 21.2 20.0124 21.1368 20.1308 21.0243C20.2492 20.9118 20.3158 20.7591 20.3158 20.6C20.3158 20.4409 20.2492 20.2882 20.1308 20.1757C20.0124 20.0632 19.8517 20 19.6842 20ZM24.0547 18.428C24.1031 18.3187 24.1163 18.1983 24.0927 18.0819C24.0691 17.9655 24.0098 17.8584 23.9221 17.774L20.1326 14.174C20.0804 14.1273 20.0207 14.0888 19.9558 14.06C19.937 14.0575 19.9178 14.0575 19.8989 14.06L19.7221 14H15.8947C15.3922 14 14.9103 14.1896 14.555 14.5272C14.1996 14.8648 14 15.3226 14 15.8V24.2C14 24.6774 14.1996 25.1352 14.555 25.4728C14.9103 25.8103 15.3922 26 15.8947 26H19.6842C19.8517 26 20.0124 25.9368 20.1308 25.8243C20.2492 25.7118 20.3158 25.5591 20.3158 25.4C20.3158 25.2409 20.2492 25.0882 20.1308 24.9757C20.0124 24.8632 19.8517 24.8 19.6842 24.8H15.8947C15.7272 24.8 15.5666 24.7368 15.4481 24.6243C15.3297 24.5118 15.2632 24.3591 15.2632 24.2V15.8C15.2632 15.6409 15.3297 15.4883 15.4481 15.3757C15.5666 15.2632 15.7272 15.2 15.8947 15.2H19.0526V17C19.0526 17.4774 19.2523 17.9352 19.6076 18.2728C19.9629 18.6104 20.4449 18.8 20.9474 18.8H23.4737C23.5984 18.7994 23.7201 18.7638 23.8235 18.6976C23.9269 18.6314 24.0074 18.5376 24.0547 18.428ZM20.9474 17.6C20.7799 17.6 20.6192 17.5368 20.5008 17.4243C20.3824 17.3117 20.3158 17.1591 20.3158 17V16.046L21.9516 17.6H20.9474ZM25.3684 20H22.2105C22.043 20 21.8824 20.0632 21.7639 20.1757C21.6455 20.2882 21.5789 20.4409 21.5789 20.6V25.4C21.5793 25.5085 21.6105 25.615 21.6695 25.708C21.7284 25.8009 21.8128 25.877 21.9137 25.928C22.0125 25.9762 22.1228 25.9987 22.2337 25.9935C22.3446 25.9882 22.452 25.9553 22.5453 25.898L23.7895 25.118L25.0526 25.898C25.147 25.9498 25.2539 25.9776 25.3629 25.9786C25.4718 25.9795 25.5792 25.9537 25.6746 25.9036C25.77 25.8535 25.8501 25.7808 25.9071 25.6925C25.9641 25.6042 25.9961 25.5035 26 25.4V20.6C26 20.4409 25.9334 20.2882 25.815 20.1757C25.6966 20.0632 25.5359 20 25.3684 20ZM24.7368 24.272L24.1432 23.894C24.0387 23.8269 23.9155 23.7911 23.7895 23.7911C23.6634 23.7911 23.5403 23.8269 23.4358 23.894L22.8421 24.272V21.2H24.7368V24.272Z"
                  fill="#4ea934"
                />
              </svg>
            </div>
            <p class="title-select-cancel">Salvar como rascunho</p>
          </div>
          <div v-else class="options-modal">
            <div>
              <svg
                class="svg-modal"
                width="50"
                height="50"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                  fill="#4ea934"
                />
                <path
                  d="M17.1579 18.8H17.7895C17.957 18.8 18.1176 18.7368 18.2361 18.6243C18.3545 18.5117 18.4211 18.3591 18.4211 18.2C18.4211 18.0409 18.3545 17.8883 18.2361 17.7757C18.1176 17.6632 17.957 17.6 17.7895 17.6H17.1579C16.9904 17.6 16.8297 17.6632 16.7113 17.7757C16.5929 17.8883 16.5263 18.0409 16.5263 18.2C16.5263 18.3591 16.5929 18.5117 16.7113 18.6243C16.8297 18.7368 16.9904 18.8 17.1579 18.8ZM19.6842 22.4H17.1579C16.9904 22.4 16.8297 22.4632 16.7113 22.5757C16.5929 22.6882 16.5263 22.8409 16.5263 23C16.5263 23.1591 16.5929 23.3118 16.7113 23.4243C16.8297 23.5368 16.9904 23.6 17.1579 23.6H19.6842C19.8517 23.6 20.0124 23.5368 20.1308 23.4243C20.2492 23.3118 20.3158 23.1591 20.3158 23C20.3158 22.8409 20.2492 22.6882 20.1308 22.5757C20.0124 22.4632 19.8517 22.4 19.6842 22.4ZM19.6842 20H17.1579C16.9904 20 16.8297 20.0632 16.7113 20.1757C16.5929 20.2882 16.5263 20.4409 16.5263 20.6C16.5263 20.7591 16.5929 20.9118 16.7113 21.0243C16.8297 21.1368 16.9904 21.2 17.1579 21.2H19.6842C19.8517 21.2 20.0124 21.1368 20.1308 21.0243C20.2492 20.9118 20.3158 20.7591 20.3158 20.6C20.3158 20.4409 20.2492 20.2882 20.1308 20.1757C20.0124 20.0632 19.8517 20 19.6842 20ZM24.0547 18.428C24.1031 18.3187 24.1163 18.1983 24.0927 18.0819C24.0691 17.9655 24.0098 17.8584 23.9221 17.774L20.1326 14.174C20.0804 14.1273 20.0207 14.0888 19.9558 14.06C19.937 14.0575 19.9178 14.0575 19.8989 14.06L19.7221 14H15.8947C15.3922 14 14.9103 14.1896 14.555 14.5272C14.1996 14.8648 14 15.3226 14 15.8V24.2C14 24.6774 14.1996 25.1352 14.555 25.4728C14.9103 25.8103 15.3922 26 15.8947 26H19.6842C19.8517 26 20.0124 25.9368 20.1308 25.8243C20.2492 25.7118 20.3158 25.5591 20.3158 25.4C20.3158 25.2409 20.2492 25.0882 20.1308 24.9757C20.0124 24.8632 19.8517 24.8 19.6842 24.8H15.8947C15.7272 24.8 15.5666 24.7368 15.4481 24.6243C15.3297 24.5118 15.2632 24.3591 15.2632 24.2V15.8C15.2632 15.6409 15.3297 15.4883 15.4481 15.3757C15.5666 15.2632 15.7272 15.2 15.8947 15.2H19.0526V17C19.0526 17.4774 19.2523 17.9352 19.6076 18.2728C19.9629 18.6104 20.4449 18.8 20.9474 18.8H23.4737C23.5984 18.7994 23.7201 18.7638 23.8235 18.6976C23.9269 18.6314 24.0074 18.5376 24.0547 18.428ZM20.9474 17.6C20.7799 17.6 20.6192 17.5368 20.5008 17.4243C20.3824 17.3117 20.3158 17.1591 20.3158 17V16.046L21.9516 17.6H20.9474ZM25.3684 20H22.2105C22.043 20 21.8824 20.0632 21.7639 20.1757C21.6455 20.2882 21.5789 20.4409 21.5789 20.6V25.4C21.5793 25.5085 21.6105 25.615 21.6695 25.708C21.7284 25.8009 21.8128 25.877 21.9137 25.928C22.0125 25.9762 22.1228 25.9987 22.2337 25.9935C22.3446 25.9882 22.452 25.9553 22.5453 25.898L23.7895 25.118L25.0526 25.898C25.147 25.9498 25.2539 25.9776 25.3629 25.9786C25.4718 25.9795 25.5792 25.9537 25.6746 25.9036C25.77 25.8535 25.8501 25.7808 25.9071 25.6925C25.9641 25.6042 25.9961 25.5035 26 25.4V20.6C26 20.4409 25.9334 20.2882 25.815 20.1757C25.6966 20.0632 25.5359 20 25.3684 20ZM24.7368 24.272L24.1432 23.894C24.0387 23.8269 23.9155 23.7911 23.7895 23.7911C23.6634 23.7911 23.5403 23.8269 23.4358 23.894L22.8421 24.272V21.2H24.7368V24.272Z"
                  fill="white"
                />
              </svg>
            </div>
            <p class="title-select-cancel active-text">
              Salvar como rascunho
            </p>
          </div>
          <div
            v-if="trash === false"
            class="options-modal"
            @click="trash = true"
          >
            <div>
              <svg
                class="svg-modal"
                width="50"
                height="50"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                  fill="#EDEDF0"
                  fill-opacity="0.5"
                />
                <path
                  d="M14 16.4H15.3333M15.3333 16.4H26M15.3333 16.4L15.3333 24.8C15.3333 25.1182 15.4738 25.4235 15.7239 25.6485C15.9739 25.8736 16.313 26 16.6667 26H23.3333C23.6869 26 24.0261 25.8736 24.2761 25.6485C24.5262 25.4235 24.6667 25.1182 24.6667 24.8V16.4L15.3333 16.4ZM21.3333 19.4V23M18.6667 19.4V23M17.3333 16.4V15.2C17.3333 14.8817 17.4738 14.5765 17.7239 14.3515C17.9739 14.1264 18.313 14 18.6667 14H21.3333C21.6869 14 22.0261 14.1264 22.2761 14.3515C22.5262 14.5765 22.6667 14.8817 22.6667 15.2V16.4H17.3333Z"
                  stroke="#4ea934"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <p class="title-select-cancel">Mandar para a lixeira</p>
          </div>
          <div v-else class="options-modal">
            <div>
              <svg
                class="svg-modal"
                width="50"
                height="50"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                  fill="#4ea934"
                />
                <path
                  d="M14 16.4H15.3333M15.3333 16.4H26M15.3333 16.4L15.3333 24.8C15.3333 25.1182 15.4738 25.4235 15.7239 25.6485C15.9739 25.8736 16.313 26 16.6667 26H23.3333C23.6869 26 24.0261 25.8736 24.2761 25.6485C24.5262 25.4235 24.6667 25.1182 24.6667 24.8V16.4L15.3333 16.4ZM21.3333 19.4V23M18.6667 19.4V23M17.3333 16.4V15.2C17.3333 14.8817 17.4738 14.5765 17.7239 14.3515C17.9739 14.1264 18.313 14 18.6667 14H21.3333C21.6869 14 22.0261 14.1264 22.2761 14.3515C22.5262 14.5765 22.6667 14.8817 22.6667 15.2V16.4H17.3333Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <p class="title-select-cancel active-text">
              Mandar para a lixeira
            </p>
          </div>
        </div>
        <div class="div-btn-modal"
          style="display: flex; gap:10px; justify-content:end;">
            <BaseButton variant="link-info" @click="closeModal()" >
              Cancelar
            </BaseButton>
            <BaseButton variant="primary" @click="closeModalAndAction" >
              Confirmar
            </BaseButton>
          </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Detalhe from "../broadcast/ModalDetalhe";
import Multiselect from "vue-multiselect";
import EmailService from "@/services/resources/EmailService";
const serviceEmail = EmailService.build();
import Paginate from "@/components/Paginate";
import _ from "lodash";
import Vue from "vue";


export default {
  name: "listagem",
  components: {
    Detalhe,
    Multiselect,
    Paginate
  },
  data() {
    return {
      loadingView: '',
      loadingRestore: '',
      emailsLoading: false,
      navigation: [
        { link: "Aplicativos", to: "/dynamicRoute/apps" },
        { link: "Broadcast", to: "/dynamicRoute/apps/broadcast" },
        { link: "Listagem", to: "/dynamicRoute/apps/broadcast/lista" },
      ],
      showBtnEdit: false,
      showBtnCancel: false,
      showBtnDelete: false,
      options: [
        { value: "filtros", text: "Filtros" },
        { value: "mes", text: "Mês" },
      ],
      filter: null,
      status_auto: [],
      status_auto2: [],
      btnsActions: false,
      trash: false,
      loading: false,
      btnsActionsEditar: true,
      selected_public: "Todos",
      emptyText: "Sem resultados",
      broadcasts: [
      ],
      broadcasts_selecionado: {},
      fields: [
        { key: "user_id", label: "check" },
        // { key: "id", label: "ID" },
        { key: "title", label: "Título" },
        { key: "status", label: "Status" },
        { key: "from_address", label: "Remetente" },
        { key: "selected_count", label: "Selecionado" },
        { key: "fetched_count", label: "Processado" },
        { key: "delivereds_count", label: "Entregue" },
        { key: "opens_count", label: "Aberto" },
        { key: "clicks_count", label: "Clicado" },
        { key: "sairam", label: "" },
        { key: "send_at", label: "Data de Envio" },
      ],
      fieldsDelete: [
        // { key: "id", label: "ID" },
        { key: "title", label: "Título" },
        { key: "from_address", label: "Remetente" },
        { key: "send_at", label: "Data de edição" },
        { key: "restore", label: "" },
      ],
      fieldsSent: [
        // { key: "id", label: "ID" },
        { key: "title", label: "Título" },
        { key: "from_address", label: "Remetente" },
        { key: "fetched_count", label: "Enviado" },
        { key: "delivereds_count", label: "Entregue" },
        { key: "opens_count", label: "Aberto" },
        { key: "clicks_count", label: "Clicado" },
        { key: "send_at", label: "Data de Envio" },
        { key: "restore", label: "" },
      ],
      totalPage: 1,
      total: 0,
      totalText: 'Broadcasts',
      rowClass: "row-table-body",
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      filterOn: [],
      selecteds_status: [],
    };
  },

  mounted() {
    this.getList();
    this.totalRows = this.broadcasts.length;
  },
  methods: {
    toPage(page) {
      this.currentPage = page;
      this.getList();
    },
    viewEvents(id) {
      this.$router.push({
        name: "Lista de Eventos",
        query: {
          email: id,
        },
      });
    },
    reload() {
      this.getList();
      this.totalRows = this.broadcasts.length;
    },
    insereModal(broadcast) {
      if(broadcast.percentageDelivereds == undefined){
        return;
      }
      this.loadingView = broadcast.id
      serviceEmail
        .read(`${broadcast.id}?append=true`)
        .then((resp) => {
          this.broadcasts_selecionado = this.parseEvents({...broadcast, ...resp});
          this.$bvModal.show("bv-modal-detalhe");
        })
        .catch((err) => {})
        .finally(() => {
          this.loadingView = '';
        });
    },
    restore(id) {
      this.loadingRestore = id
      serviceEmail
        .read(id)
        .then((resp) => {
          if (resp.fetched_count) {
            this.$grToast.toast("Não é possível restaurar um e-mail que já foi enviado", {
              title: "Broadcast",
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            });
            this.loadingRestore = ''
          } else {
            let data = resp
            data.status = -1;
            serviceEmail
              .create(data)
              .then((response) => {
                let broadIndex = this.broadcasts.findIndex(broad => broad.id == id)
                if(!broadIndex && broadIndex !== 0) {return}
                this.broadcasts.splice(broadIndex, 1);
                this.$grToast.toast(`O e-mail foi restaurado como um rascunho`, {
                  title: "Broadcast",
                  variant: "success",
                  autoHideDelay: 5000,
                  appendToast: true,
                });
              })
              .catch((err) => {});
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loadingRestore = '';
        });
    },
    selectPublic() {
      this.btnsActions = false;
      this.status_auto = [];
      this.status_auto2 = [];
      this.currentPage = 1;
      this.getList();
    },
    lastPage() {
      if (this.currentPage === 1) {
      } else {
        this.currentPage = this.currentPage - 1;
        this.getList();
      }
    },
    actionDeletar() {
      let itens = this.status_auto;
      for (let i = 0; i < itens.length; i++) {
        const status = this.selecteds_status[i]
        if (status > 0) {
          continue
        }
        const element = itens[i];
        serviceEmail
          // .destroy(element)
          .destroy(element)
          .then((resp) => {
            this.btnsActions = false;
            this.btnsActionsEditar = true;
            for (let i = 0; i < this.status_auto.length; i++) {
              this.status_auto.shift();
            }
            this.getList();
            this.verificaBtn();

            this.btnsActions = this.btnsActions;
            this.$grToast.toast(`Broadcast ${element} deletado com sucesso!`, {
              title: "Broadcast",
              variant: "success",
              autoHideDelay: 5000,
              appendToast: true,
            });
          })
          .catch((err) => {
            console.error(err);
            this.$grToast.toast(
              `Erro ao tentar deletar broadcast ${element}!`,
              {
                title: "Broadcast",
                variant: "danger",
                autoHideDelay: 5000,
                appendToast: true,
              }
            );
          });
      }
    },
    actionEditar(acao) {
      this.$router.push(
        "/dynamicRoute/apps/broadcast/wizard?edit=" + this.status_auto[0]
      );
    },
    actionDelete(){
      this.$refs["my-modal-cancel"].show();
    },
    closeModal(){
      this.$refs["my-modal-cancel"].hide();
    },
    async closeModalAndAction() {
      for (let index = 0; index < this.status_auto.length; index++) {
        const status = this.selecteds_status[index]
        if (status != 0) {
          continue
        }
        const id = this.status_auto[index];
        await this.cancelShipping(id);
      }
      this.$refs["my-modal-cancel"].hide();
    },
    cancelShipping(id) {
      let status = -1;
      if (this.trash) {
        status = -2;
      } 
      serviceEmail
        .update({id: `${id}/change-status`, status: status})
        .then((resp) => {
          if(!resp.success){
            this.$grToast.toast("Não é possível cancelar o envio desse e-mail por conta de seu status", {
              title: "Broadcast",
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            });
            return;
          }
          let broadIndex = this.broadcasts.findIndex(broad => broad.id == id)
          if(!broadIndex && broadIndex !== 0) {return}
          if (!this.trash) {
            let broadcasts = this.broadcasts;
            broadcasts[broadIndex].status = -1;
            broadcasts[broadIndex].status_text = 'Rascunho';
            this.broadcasts = broadcasts;
          } else {
            this.broadcasts.splice(broadIndex, 1);
          }
          this.total = this.total - 1;
        })
        .catch((err) => {});
    },
    clickCheck() {
      if ( this.selecteds_status.length && this.selecteds_status.every(status => status == 0)) {
        this.showBtnCancel = true;
      } else {
        this.showBtnCancel = false;
      }
      this.verificaBtn();
    },
    clickCheckAll() {
      if (
        this.status_auto.length === 0 ||
        this.status_auto.length != this.broadcasts.filter(broad => broad.status < 1).length
      ) {
        let broadcasts = this.broadcasts;
        let array = [];
        for (let i = 0; i < broadcasts.length; i++) {
          const element = broadcasts[i];
          if (element.status < 1) {
            array.push(element.id);
          }
        }
        this.status_auto = array;
        this.verificaBtn();
      } else {
        this.status_auto = [];
        this.status_auto2 = [];
        this.verificaBtn();
      }
    },
    verificaBtn() {
      if (this.status_auto.length !== 0) {
        this.btnsActions = true;
      } else if (this.status_auto.length === 0) {
        this.btnsActions = false;
        this.status_auto2 = [];
      }
    },
    nextPage() {
      if (this.currentPage === this.totalPage) {
      } else {
        this.currentPage = this.currentPage + 1;
        this.getList();
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      // this.currentPage = 1
    },
    debounce: _.debounce(function () {
      this.currentPage = 1
      this.getList();
    }, 500),
    removeLoading() {
      setTimeout(function () {
        let div = document.querySelectorAll(".fakeListen");
        for (let i = 0; i < div.length; i++) {
          div[i].classList.remove("divFakeLista");
        }
      }, 30);
    },
    getList() {
      this.loading = false;
      let div = document.querySelectorAll(".fakeListen");
      for (let i = 0; i < div.length; i++) {
        div[i].classList.add("divFakeLista");
      }

      this.emailsLoading = true;

      let status = 'todos'
      if (this.selected_public == 'Enviados') {
        status = 'delivered' 
      } else if (this.selected_public == 'Deletados') {
        status = 'deleted'  
      }

      serviceEmail
        .read(`?page=${this.currentPage}&status=${status}&search=${this.filter ?? ""}&per_page=5`)
        .then((resp) => {
          this.total = resp.total
          this.totalText = this.selected_public == 'Enviados' ? 'Broadcasts enviados' : this.selected_public == 'Deletados' ? 'Broadcasts deletados' : 'Broadcasts'
          this.emailsLoading = false;

          let dados = resp.data;

          let emptyEvents = {
            fetched_count: 0,
            filtereds_count: 0,
            delivereds_count: 0,
            unsubscribeds_count: 0,
            bounceds_count: 0,
            deferreds_count: 0,
            droppeds_count: 0,
            spams_count: 0,
            opens_count: 0,
            clicks_count: 0,
            percentageOpen: 0,
            percentageClick: 0,
            percentageUnsubscribeds: 0,
            percentageDelivereds: 0,
            percentageSpam: 0,
            percentageDroppped: 0,
            percentageBounce: 0
          }
      
          for (let i = 0; i < dados.length; i++) {
            if (dados[i].title === "") {
              dados[i].title = "Sem título";
            }

            if (dados[i].from_address === "") {
              dados[i].from_address = "Sem remetente";
            }

            //muda status
            switch (dados[i].status) {
              case -2:
                dados[i].status_text = "Deletado";
                break;
              case -1:
                dados[i].status_text = "Rascunho";
                break;
              case 0:
                dados[i].status_text = "Aguardando";
                break;
              case 1:
              case 2:
              case 3:
                dados[i].status_text = "Enviando";
                break;
              case 4:
                dados[i].status_text = "Enviado";
                break;
              case 5:
                dados[i].status_text = "Erro";
                break;
            }
          }
          this.broadcasts = resp.data;

          for (let i = 0; i < this.broadcasts.length; i++) {
            const broadcast = this.broadcasts[i];
            if(broadcast.status === 4){
              this.getEmailEvents(broadcast, i)
            }else{
              Vue.set(this.broadcasts, i, {...this.broadcasts[i], ...emptyEvents});
            }

          }

          this.totalPage = resp.last_page;
          this.currentPage = resp.current_page;
          this.removeLoading();
          this.loading = true;
        })
        .catch((err) => {});
    },
    getEmailEvents(broadcast, index = 0){
      serviceEmail
        .read({id: `${broadcast.id}/events-count?appends=delivereds_count,opens_count,clicks_count,unsubscribeds_count`})
        .then((resp) => {
          //insere e calcula porcentagem
          let moldedEvents = this.parseEvents({...broadcast, ...resp});
          Vue.set(this.broadcasts, index, moldedEvents);
        }) 
    },
    parseEvents(broadcast){
      var enviado = broadcast.fetched_count;
      if (broadcast.selected_count !== 1 && broadcast.fetched_count === 1) {
        enviado = broadcast.selected_count;
      }

      let aberto = broadcast.opens_count;
      let clicks = broadcast.clicks_count;
      let spam = broadcast.spams_count;
      let dropped = broadcast.droppeds_count;
      let bounce = broadcast.bounceds_count;
      let unsubscribeds = broadcast.unsubscribeds_count;
      let deferreds = broadcast.deferreds_count;
      let delivereds = broadcast.delivereds_count;

      if (enviado === 0 || enviado === "0") {
        broadcast.percentageOpen = 0;
        broadcast.percentageClick = 0;
        broadcast.percentageSpam = 0;
        broadcast.percentageDroppped = 0;
        broadcast.percentageBounce = 0;
        broadcast.percentageUnsubscribeds = 0;
        broadcast.percentageDeferreds = 0;
        broadcast.percentageDelivereds = 0;
      } else if (enviado === null) {
        let enviado2 = broadcast.filtereds_count;

        if (enviado2 === null || enviado2 === 0 || enviado2 === "0") {
          broadcast.percentageOpen = 0;
          broadcast.percentageClick = 0;
          broadcast.percentageSpam = 0;
          broadcast.percentageDroppped = 0;
          broadcast.percentageBounce = 0;
          broadcast.percentageUnsubscribeds = 0;
          broadcast.percentageDeferreds = 0;
          broadcast.percentageDelivereds = 0;
        } else {
          let porcentagemAberto = (aberto / enviado2) * 100;
          let porcentagemClicado = (clicks / enviado2) * 100;
          let porcentagemSpam = (spam / enviado2) * 100;
          let porcentagemDropped = (dropped / enviado2) * 100;
          let porcentagemBounce = (bounce / enviado2) * 100;
          let porcentagemUnsubscribeds = (unsubscribeds / enviado2) * 100;
          let porcentagemDeferreds = (deferreds / enviado2) * 100;
          let porcentagemDelivereds = (delivereds / enviado2) * 100;

          broadcast.percentageOpen = parseInt(porcentagemAberto, 10);
          broadcast.percentageClick = parseInt(porcentagemClicado, 10);
          broadcast.percentageSpam = parseInt(porcentagemSpam, 10);
          broadcast.percentageDroppped = parseInt(porcentagemDropped, 10);
          broadcast.percentageBounce = parseInt(porcentagemBounce, 10);
          broadcast.percentageUnsubscribeds = parseInt(
            porcentagemUnsubscribeds,
            10
          );
          broadcast.percentageDeferreds = parseInt(porcentagemDeferreds, 10);
          broadcast.percentageDelivereds = parseInt(porcentagemDelivereds, 10);
        }
      } else {
        let porcentagemAberto = (aberto / enviado) * 100;
        let porcentagemClicado = (clicks / enviado) * 100;
        let porcentagemSpam = (spam / enviado) * 100;
        let porcentagemDropped = (dropped / enviado) * 100;
        let porcentagemBounce = (bounce / enviado) * 100;
        let porcentagemUnsubscribeds = (unsubscribeds / enviado) * 100;
        let porcentagemDeferreds = (deferreds / enviado) * 100;
        let porcentagemDelivereds = (delivereds / enviado) * 100;

        broadcast.percentageOpen = parseInt(porcentagemAberto, 10);
        broadcast.percentageClick = parseInt(porcentagemClicado, 10);
        broadcast.percentageSpam = parseInt(porcentagemSpam, 10);
        broadcast.percentageDroppped = parseInt(porcentagemDropped, 10);
        broadcast.percentageBounce = parseInt(porcentagemBounce, 10);
        broadcast.percentageUnsubscribeds = parseInt(
          porcentagemUnsubscribeds,
          10
        );
        broadcast.percentageDeferreds = parseInt(porcentagemDeferreds, 10);
        broadcast.percentageDelivereds = parseInt(porcentagemDelivereds, 10);
      }

      return broadcast;
    }
  },
  watch: {
    status_auto(e) {
      this.selecteds_status = this.status_auto.map(email_id => email_id = this.broadcasts.find((x) => x.id == email_id).status);
      if (
        this.selecteds_status.indexOf(0) !== -1
      ) {
        this.showBtnCancel = true;
      } else {
        this.showBtnCancel = false;
      }
      if (
        this.status_auto.length == 1 &&
        (this.selecteds_status[0] == 0 || this.selecteds_status[0] == -1)
      ) {
        this.showBtnEdit = true;
      } else {
        this.showBtnEdit = false;
      }
      if (this.selecteds_status.indexOf(-1) !== -1 || this.selecteds_status.indexOf(0) !== -1) {
        this.showBtnDelete = true
      } else {
        this.showBtnDelete = false
      }
    },
  },
};
</script>
<style lang="scss">
.status-broadcast-select {
  .multiselect__tags{
    padding: 11px 25px 15px 50px !important;
  }
}
.broadcast-html .table thead th {
  background-color: transparent !important;
}
.title-select-cancel{
  margin: auto 0px;
}
.options-modal {
  gap: 10px;
  margin-bottom: 20px;
  border: 1px solid #ededf0;
  padding: 15px 20px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  transition: all 0.5s;
}
.top {
  ul {
    display: flex;
    gap: 10px;
    a {
      transition: all 0.3s;
      font-size: 14px;
      color: #81858e;
      font-weight: 500;
      text-decoration: none;
      &:hover {
        color: #57585c !important;
      }
    }

    li {
      display: flex;
      gap: 10px;

      a {
        transition: all 0.3s;
        font-size: 14px;
        color: #81858e;
        font-weight: 500;
        text-decoration: none;
        &:hover {
          color: #57585c !important;
        }
      }
    }
  }
}
.broadcast-html {
  button.btn.dropdown-toggle.btn-secondary {
    background: #ffffff00;
    border: none;
    color: #000;
    height: 20px;
    position: relative;
    left: -22px;
  }

  .dropFilter {
    button.btn.dropdown-toggle.btn-secondary {
      height: 50px;
      background:  var(--greenn);
      border: none;
      color: #000;
      position: relative;
      left: 0px;
      margin-top: -18px;
      border-radius: 10px !important;
      transition: all 0.3s;

      &:hover {
        transform: scale(1.05);
      }
    }
    .btn-secondary:not(:disabled):not(.disabled):active:focus,
    .btn-secondary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-secondary.dropdown-toggle:focus {
      border: none;
      box-shadow: none;
    }

    .btn-secondary:not(:disabled):not(.disabled):active,
    .btn-secondary:not(:disabled):not(.disabled).active,
    .show > .btn-secondary.dropdown-toggle {
      color: #00000000;
      background-color: var(--greenn-light) !important;
      border-color: transparent;
      border: none;
      outline: none;
    }
  }

  .btn-secondary:not(:disabled):not(.disabled):active:focus,
  .btn-secondary:not(:disabled):not(.disabled).active:focus,
  .show > .btn-secondary.dropdown-toggle:focus {
    -webkit-box-shadow: 0 0 0 0.2rem #ffffff00;
    box-shadow: 0 0 0 0.2rem #ffffff00;
  }

  .btn-secondary:not(:disabled):not(.disabled):active,
  .btn-secondary:not(:disabled):not(.disabled).active,
  .show > .btn-secondary.dropdown-toggle {
    color: #000;
    background-color: #fff;
    border-color: #fff;
  }
}
</style>
<style lang="scss">

.options-modal {
    margin-bottom: 20px;
    border: 1px solid #ededf0;
    padding: 15px 20px;
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    align-items: baseline;
    transition: all 0.5s;
  }
.lista-wizard {
  .broadcast-html {
    .flex-test {
      display: flex;
      margin-bottom: 30px !important;
      margin-top: 15px !important;
      justify-content: space-between;
    }
    .wizard {
      #bar {
        color: #fff;
        display: flex;
        top: 25px;
        position: relative;
      }

      .daterangepicker td.active,
      .daterangepicker td.active:hover {
        background-color: var(--greenn) !important;
      }

      #modal-list .nav-tabs .nav-link.active,
      .nav-tabs .nav-item.show .nav-link {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        color: var(--greenn);
      }

      #modal-list .modal-body {
        padding: 10px;
      }

      #modal-list .modal-dialog.modal-md {
        max-width: 1000px;
      }

      #modal-list .nav-link {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        color: #333;
      }

      #trasmicao
        .daterangepicker.dropdown-menu.ltr.show-calendar.show-ranges.show-weeknumbers.openscenter.linked {
        margin-left: 186px;
        margin-top: 22px;
      }

      #modal-list .modal-header {
        border: none !important;
      }

      #remetente select.select-filter-options.custom-select {
        // background-color: var(--greenn-transparent2);
        // border: 1px solid var(--greenn);
        border: 1px solid #ededf0;
        background-color: #fff;
        box-sizing: border-box;
        border-radius: 5px;
        width: 388px;
        height: 55px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
      }

      #remetente select.select-filter-options.custom-select:focus {
        background-color: var(--greenn-transparent2);
        border: 1px solid  var(--greenn);
      }

      #remetente select.select-filter-options.custom-select:hover {
        background-color: var(--greenn-transparent2);
        border: 1px solid  var(--greenn);
      }

      select#select-teste-ab {
        height: 50px;
        border: 1px solid #ededf0;
        background-color: #fff;
        box-sizing: border-box;
        width: 95%;
        border-radius: 5px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
      }

      select#select-teste-ab:focus {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      select#select-teste-ab:hover {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #modal-remetente {
        position: fixed;
        width: 370px;
        height: 400px;
        left: 74%;
        top: 9%;
      }

      #modal-remetente .addremetenteinput {
        width: 280px;
        height: 40px;
        border: 0.5px solid #e5e5e5;
        box-sizing: border-box;
        border-radius: 3px;
        margin-bottom: 20px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
      }

      #modal-remetente button.close {
        color: #000 !important;
        opacity: inherit;
      }

      #modal-remetente .modal-content {
        width: 315px;
        height: 90% !important;
        margin: inherit;
        margin-right: 4% !important;
      }

      #modal-remetente .modal-header {
        border: none;
        margin-bottom: -15px;
      }

      #trasmicao .multiselect.input-maior-select .multiselect__tags {
        width: 369px;
      }

      #trasmicao .multiselect__tags {
        width: 335px;
        padding-top: 11px;
        border: 1px solid #ededf0;
        box-sizing: border-box;
        border-radius: 5px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        letter-spacing: 0.2px;
        color: #000;
        font-size: 13px;
        overflow: auto;
      }

      #trasmicao .multiselect__tags:hover {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #trasmicao .multiselect__tags:focus {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #automacao .multiselect__tags {
        width: 315px;
        padding-top: 11px;
        border: 1px solid #ededf0;
        box-sizing: border-box;
        border-radius: 5px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        letter-spacing: 0.2px;
        color: #000;
        height: 50px;
        font-size: 13px;
        overflow: auto;
      }

      div#modal-preview {
        width: 100%;
        height: 100%;
      }

      #modal-list thead {
        background: #f5f2fc80;
      }

      #modal-list .table thead th {
        border: none;
      }

      #modal-list .table-sm th,
      .table-sm td {
        border: none;
        padding-top: 10px;
      }

      #modal-preview .modal-dialog.modal-md {
        width: 466px !important;
        height: 565px !important;
        position: relative !important;
        top: 46% !important;
        -webkit-transform: translateY(-54%) !important;
        transform: translateY(-51%) !important;
      }

      #modal-preview .modal-header {
        border: none;
      }

      #modal-preview .modal-content {
        height: 89% !important;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
      }

      #automacao .custom-control-input:checked ~ .custom-control-label::before {
        color: #fff;
        border-color: var(--greenn);
        background-color: var(--greenn);
      }

      #automacao .multiselect__tags:hover {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #automacao .multiselect__tags:focus {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #trasmicao select.select-filter-options.custom-select {
        border: 1px solid #ededf0;
        box-sizing: border-box;
        border-radius: 5px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        letter-spacing: 0.2px;
        color: #000;
        height: 50px;
        font-size: 13px;
        width: 330px;
        display: block;
      }

      #automacao input.input-auto-style.input-select-action.form-control {
        border: 1px solid #ededf0;
        box-sizing: border-box;
        border-radius: 5px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        letter-spacing: 0.2px;
        color: #000;
        height: 50px;
        font-size: 13px;
        background-color: #fff;
      }

      #automacao input.input-auto-style.input-select-action.form-control:hover {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #automacao input.input-auto-style.input-select-action.form-control:focus {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #automacao input.input-auto-style.input-number-auto.form-control {
        border: 1px solid #ededf0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 5px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        letter-spacing: 0.2px;
        color: #000;
        height: 50px;
        font-size: 13px;
        background-color: #fff;
      }

      #automacao textarea.input-auto-style.form-control {
        border: 1px solid #ededf0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 5px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        letter-spacing: 0.2px;
        color: #000;
        height: 50px;
        font-size: 13px;
        background-color: #fff;
        width: 280px;
      }

      #automacao input.input-auto-style.input-number-auto.form-control:hover {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #automacao input.input-auto-style.input-number-auto.form-control:focus {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #trasmicao .vue-slider-process {
        background-color: var(--greenn);
        border-radius: 15px;
      }

      #trasmicao .vue-slider-dot-handle {
        cursor: pointer;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        -webkit-box-shadow: 0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.32);
        box-shadow: 0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.32);
        background: #ccfaec;
        border: 1px solid var(--greenn);
        box-sizing: border-box;
        border-radius: 50%;
      }

      #trasmicao .vue-slider-dot-tooltip-inner {
        font-size: 14px;
        white-space: nowrap;
        padding: 2px 5px;
        min-width: 20px;
        text-align: center;
        color: #000;
        border-radius: 5px;
        border-color: #fff;
        background-color: #fff;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
        margin-bottom: -5px;
      }

      #trasmicao .multiselect__select {
        top: 7px !important;
      }

      #trasmicao .multiselect__input,
      .multiselect__single {
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        color: #000;
      }

      #trasmicao .form-control.reportrange-text {
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        color: #000;
        height: 50px;
        border: 1px solid #ededf0;
        box-sizing: border-box;
        border-radius: 5px;
        padding: 16px;
      }

      #trasmicao .form-control.reportrange-text:hover {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #trasmicao .form-control.reportrange-text:focus {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #trasmicao .multiselect__content-wrapper {
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        color: #000;
      }

      #trasmicao .multiselect__placeholder {
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        color: #000;
      }

      #automacao .multiselect__content-wrapper {
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        color: #000;
      }

      #automacao .multiselect__placeholder {
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        color: #000;
      }

      #trasmicao select.select-filter-options.custom-select:hover {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #trasmicao select.select-filter-options.custom-select:focus {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #envio .form-control.reportrange-text {
        display: block;
        margin-top: 0px;
        width: 221px;
        border: 1px solid #ededf0;
        box-sizing: border-box;
        border-radius: 5px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        height: 50px;
        font-size: 13px;
        letter-spacing: 0.2px;
        color: #000;
        padding: 15px;
      }

      #envio .form-control.reportrange-text:hover {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }

      #envio .form-control.reportrange-text:focus {
        background-color: var(--greenn-transparent2);
        border: 1px solid var(--greenn);
      }
    }
  }
  .wrap-pages{
    display: none !important;
  }
}
td:has(.deleted-actions) {
  width: 35px !important;
  &:has(.restore){
    width: 160px !important;
  }
  vertical-align: middle;
}
</style>
<style scoped lang="scss">
@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

.loading {
  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%) !important;
  background-size: 200% 100%;
  animation: 1s shine linear infinite;
  stroke: var(--greenn) !important;
  fill: var(--greenn) !important;
  color: var(--greenn) !important;
  transition: 0s !important;
  cursor: wait !important;
}
.deleted-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  width: fit-content;
  > * {
    height: 35px;
    padding: 0px 15px;
    border: 1px solid var(--greenn);
    background-color: transparent;
    color: var(--greenn);
    border-radius: 10px;
    line-height: 1;
    transition: .3s;
    stroke: var(--greenn);
    fill: var(--greenn);
    &:hover {
      background-color: var(--greenn);
      color: white;
      stroke: white;
      fill: white;
    }
  }
  > div {
    cursor: pointer;
    width: 35px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.lista-wizard {
  
  .title-modal {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    text-align: center;
  }

  .content-option-modal {
    margin-top: 20px;
    transition: all 0.5s;
  }

  .title-select-cancel {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: #000;
    letter-spacing: 0.2px;
    margin-left: 17px;
    margin-top: 8px;
  }
  .active-text {
    color: var(--greenn) !important;
  }
  .broadcast-html {
    .pointerx {
      width: 9px;
      height: 9px;
      background: var(--greenn);
      border-radius: 1px;
      margin-top: 10px;
      margin-right: 15px;
    }

    .divFakeLista {
      color: #ededf000 !important;
      border-radius: 6px;
      animation: preload 0.8s forwards linear infinite alternate;
      background: #ededf0;
    }

    @keyframes preload {
      from {
        background: #ededf0;
      }

      to {
        background: rgb(192, 192, 192);
      }
    }

    .btn-pagination:hover {
      color: var(--greenn);
    }

    .btn-pagination:hover svg {
      filter: invert(0.4) sepia(1) saturate(5) hue-rotate(106.2deg)
        brightness(1.2);
    }

    .btns-actions {
      border: none;
      border: 1px solid var(--greenn);
      box-sizing: border-box;
      border-radius: 10px;
      height: 38px;
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      letter-spacing: 0.2px;
      color: var(--greenn);
      stroke: var(--greenn);
      fill: var(--greenn);
      margin-right: 20px;
      background-color: white;
      width: 136px;
      margin-bottom: 20px;
      cursor: pointer;
      &:disabled {
        border-color: var(--white-dark);
        color: var(--white-dark);
        stroke: var(--white-dark);
        fill: var(--white-dark);
        cursor: default;
      }
      path {
        stroke: inherit;
        fill: inherit;
      }
    }

    svg.icon_select_svg {
      position: relative;
      top: 10px;
      cursor: pointer;
    }

    select.select_ative.custom-select {
      width: 0px;
      position: relative;
      left: -28px;
      background: #0000;
      appearance: none;
    }

    .title-open.title-espacamento {
      overflow: hidden;
      text-overflow: ellipsis;
      width: 200px;
    }

    p.text-filter {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 150%;
      display: flex;
      align-items: center;
      color: #333;
      position: relative;
      bottom: 15px;
      left: 33px;
    }

    svg.arrow-filter {
      position: relative;
      left: 8px;
    }

    p.title.text-center-empty {
      display: flex;
      width: 100%;
      justify-content: center;
      margin-top: 40px;
      margin-bottom: 20px;
    }

    .espacamento-svg-action {
      margin-right: 5px;
      margin-bottom: 3px;
    }

    .btn-pagination {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.2px;
      color: #333333;
      background-color: white;
      border: none;
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .list-reload {
      display: flex;
      align-items: center;
      gap: 20px;
    }
    .btn-reload {
      cursor: pointer;
      height: 50px;
      width: 50px;
      background: var(--greenn);
      border: none;
      color: #000;
      position: relative;
      left: 0px;
      transition: all 0.3s;
      border-radius: 10px;

      &:hover {
        transform: scale(1.05);
      }
      &:hover {
        transform: scale(1.05);
      }
    }

    .number-active {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 48px;
      letter-spacing: 0.2px;
      color: #000000;
      width: 64px;
      height: 50px;
      border: 1px solid #ededf0;
      box-sizing: border-box;
      border-radius: 3px;
    }
    .text-pagination {
      font-family: Montserrat;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      letter-spacing: 0.2px;
      color: #333333;
      padding-top: 16px;
      padding-right: 20px;
    }

    .espace-pagination {
      margin: 50px 0px;
      display: flex;
      align-items: flex-end;
      justify-content: space-evenly;
    }

    ul.pagination.my-0.b-pagination.pagination-sm.text-center {
      padding-right: 100px;
    }

    .title-open {
      cursor: pointer;
      color: var(--gray03);
      font-weight: 500;
    }

    .text-pagination2 {
      font-family: Montserrat;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      letter-spacing: 0.2px;
      color: #333333;
      padding-top: 16px;
      padding-left: 10px;
      white-space: nowrap;
    }

    .prev-text {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.2px;
      color: #333333;
    }

    .next-text {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.2px;
      color: var(--greenn);
    }

    .cursor {
      cursor: pointer;
    }

    .hide {
      display: none !important;
    }

    .check {
      padding-left: 4px;
      cursor: pointer;
      position: relative;
      top: 5.5px;
    }

    .content-clicados {
      min-width: 78px;
      height: 32.73px;
      background: rgba(46, 215, 238, 0.1);
      border-radius: 5px;
      justify-content: space-evenly;
      display: flex;
      margin-top: 10px;
      align-items: center;
    }
    .filter-search {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      position: relative;
    }

    .pointer-clicados {
      background: #2ed7ee;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-top: auto;
      margin-bottom: auto;
    }

    .value-clicados {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      color: #2ed7ee;
      display: contents;
    }

    .content-abertos {
      min-width: 78px;
      height: 32.73px;
      background: rgba(255, 203, 55, 0.1);
      border-radius: 5px;
      justify-content: space-evenly;
      display: flex;
      margin-top: 10px;
      align-items: center;
    }

    span.checkmark {
      background: #ededf0;
      border: 1px solid var(--greenn);
      box-sizing: border-box;
      border-radius: 2px;
    }

    .pointer-abertos {
      background: #ffcb37;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-top: auto;
      margin-bottom: auto;
    }

    .value-abertos {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      color: #ffcb37;
      display: contents;
    }

    .content-enviados {
      min-width: 78px;
      height: 32.73px;
      background: var(--greenn2);
      border-radius: 5px;
      justify-content: space-evenly;
      display: flex;
      margin-top: 10px;
      align-items: center;
    }

    .pointer-entregues {
      background: #333;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-top: auto;
      margin-bottom: auto;
    }

    .content-entregues {
      min-width: 78px;
      height: 32.73px;
      background: #0000002d;
      border-radius: 5px;
      justify-content: space-evenly;
      display: flex;
      margin-top: 10px;
      align-items: center;
    }

    .value-allblack {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      color: #000000;
      display: contents;
    }

    .pointer-enviados {
      background: var(--greenn);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-top: auto;
      margin-bottom: auto;
    }

    .value-enviados {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      color: var(--greenn);
      display: contents;
    }

    .radius {
      border-radius: 5px;
    }

    .form-check-input {
      margin-left: 0px !important;
    }

    .div-btn {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 71%;
      justify-content: flex-end;
    }

    .table {
      width: 98%;
      margin-bottom: 1rem;
      color: #212529;
    }

    .flex {
      display: flex;
    }

    button.new-broadcast {
      width: 219px;
      height: 50px;
      border: none;
      background: var(--greenn);
      border-radius: 10px;
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      align-items: center;
      letter-spacing: 0.2px;
      transition: all 0.3s;
      color: #fff;
      right: 55px;
      &:hover {
        transform: scale(1.05);
      }
    }

    .input-search {
      margin-right: 25px;
      background: transparent;
      border: 1px solid var(--greenn);
      box-sizing: border-box;
      border-radius: 5px;
      width: 287px;
      height: 50px !important;
    }

    .svg-data-feed {
      margin-right: 0px;
      margin-top: 9px;
      position: absolute;
      margin-left: 10px;
    }

    .table-responsive-sm {
      margin-left: 20px;
      width: 98%;
    }

    .custom-select {
      width: 100%;
      height: calc(1.5em + 0.75rem + 2px);
      padding: 0.375rem 1.75rem 0.375rem 0.75rem;
      color: #333333;
      appearance: auto;
      border: 0.5px solid #ededf0;
      box-sizing: border-box;
      box-shadow: 0px 4px 4px rgba(237, 237, 240, 0.1);
      border-radius: 3px;
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 150%;
      display: flex;
      padding-left: 30px;
      align-items: center;
      background-image: none;
      padding-right: 13px;
      border: none;
    }

    .content-initial {
      width: 98%;
      display: flex;
      margin-left: 20px;
      // background: #fdfcff;
      margin-top: -20px;
    }

    .title {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      color: #333333;
      margin-bottom: 30px;
      margin-top: 5px;
    }

    .cabecalho {
      width: 100%;
    }

    input#input-pagination {
      width: 64px;
      height: 50px;
      border: 1px solid #ededf0;
      box-sizing: border-box;
      border-radius: 3px;
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 0.2px;
      color: #000;
      display: flex;
      text-align: -webkit-center;
    }
  }
  .wrap-pages{
    display: none !important;
  }
  .event-skeleton{
    margin-top: 10px;
  }
}
</style>
